import { render, staticRenderFns } from "./9.vue?vue&type=template&id=73e46a26&scoped=true&"
import script from "./9.vue?vue&type=script&lang=js&"
export * from "./9.vue?vue&type=script&lang=js&"
import style0 from "./9.vue?vue&type=style&index=0&id=73e46a26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e46a26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73e46a26')) {
      api.createRecord('73e46a26', component.options)
    } else {
      api.reload('73e46a26', component.options)
    }
    module.hot.accept("./9.vue?vue&type=template&id=73e46a26&scoped=true&", function () {
      api.rerender('73e46a26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/details/9.vue"
export default component.exports